"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APDatePicker = _interopRequireDefault(require("../../common/APDatePicker/APDatePicker"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APButton = _interopRequireDefault(require("../../common/APButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('order-history');
var HeaderWithFilterComponent = /*#__PURE__*/function (_React$Component) {
  function HeaderWithFilterComponent() {
    var _this;
    _classCallCheck(this, HeaderWithFilterComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HeaderWithFilterComponent, [].concat(args));
    _defineProperty(_this, "clearFilters", function () {
      var clearDate = _this.props.clearDate;
      clearDate('startDate');
      clearDate('endDate');
    });
    return _this;
  }
  _inherits(HeaderWithFilterComponent, _React$Component);
  return _createClass(HeaderWithFilterComponent, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        startDate = _this$props.startDate,
        clearDate = _this$props.clearDate;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('header-with-filter')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('header-with-filter-title')
      }, t('Transaction History')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('header-with-filter-datapicker')
      }, /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
        name: "startDate",
        customClass: baseClasses('from'),
        label: t('Date Range:'),
        maxDate: new Date(),
        format: function format(value) {
          return value;
        },
        showIcon: true,
        iconClick: function iconClick() {
          return clearDate('startDate');
        }
      }), /*#__PURE__*/_react["default"].createElement(_APDatePicker["default"], {
        name: "endDate",
        customClass: baseClasses('to'),
        label: t('to'),
        minDate: startDate,
        maxDate: new Date(),
        format: function format(value) {
          return value;
        },
        showIcon: true,
        iconClick: function iconClick() {
          return clearDate('endDate');
        }
      }), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: baseClasses('clear'),
        classModifiers: "clear-filters",
        type: "button",
        onClick: this.clearFilters
      }, t('Clear Filters'))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _reactI18next.withTranslation)('order')(HeaderWithFilterComponent);